import { firestoreAction, ReactiveVariable } from 'fire7';
import './plugins/firebase';
import firebase from 'firebase';
import Room from './classes/_Room';

const rooms = new ReactiveVariable(() => {
  rooms.value.forEach((room) => room.addUpdateListener(updateUnreadedMessages));
});


firebase.auth().onAuthStateChanged(async (user) => {
  Room.prototype.currentMemberId = user?.uid;
  if (user) bindRooms(rooms);
});

const bindRooms = firestoreAction(({ bindFirestoreRef }) => {
  let roomsRef = firebase.firestore()
      .collection(`projects/${window.projectId}/rooms`)
      .withConverter(Room.converter)
      .where('members', 'array-contains', Room.prototype.currentMemberId);

  return bindFirestoreRef('value', roomsRef);
});

function updateUnreadedMessages() {
  const count = rooms.value.reduce((sum, current) => sum + current.unreadMessagesCount, 0);
  document.querySelectorAll('#memberchat-info')
      .forEach((el) => {
        el.innerText = count;

        if (count > 0) {
          el.classList.add('unreaded');
        } else {
          el.classList.remove('unreaded');
        }
      });
}
